'use client'

import { JSX, useState } from 'react'
import { RiParentLine } from 'react-icons/ri'
import Modal from '../Modal'
import { BsBackpack2 } from 'react-icons/bs'
import { LuScrollText } from 'react-icons/lu'
import { FaRegLightbulb } from 'react-icons/fa'
import { HiMagnifyingGlass } from 'react-icons/hi2'

type ModalKey = 'prepare' | 'rules' | 'advice'



export default function ParentSection({ parentHelp, parentRules, parentWarning }: { parentHelp: string; parentRules: string[]; parentWarning: string }) {
	const [activeModal, setActiveModal] = useState<ModalKey | null>(null)

	const openModal = (key: ModalKey) => setActiveModal(key)
	const closeModal = () => setActiveModal(null)

	const modalContent: Record<ModalKey, { title: string; html: JSX.Element; icon: JSX.Element }> = {
		prepare: {
			title: 'Хүүхэддээ туслаарай',
			icon: <BsBackpack2 className="text-4xl mb-1" />,
			html: (
				<>
				<span dangerouslySetInnerHTML={{ __html: parentHelp }} />
				</>
			)
		},
		rules: {
			title: 'Таны хүүхэд юу мэдэж байх хэрэгтэй вэ?',
			icon: <LuScrollText className="text-4xl mb-1" />,
			html: (
				<div>
					<span dangerouslySetInnerHTML={{ __html: parentRules }} />
				</div>
			)
		},
		advice: {
			title: 'Та юуг мэдвэл зохистой вэ?',
			icon: <FaRegLightbulb className="text-4xl mb-2" />,
			html: (
				<>
					<span dangerouslySetInnerHTML={{ __html: parentWarning }} />
				</>
			)
		}
	}

	return (
		<div className='relative bg-brandsky-900 pb-4 overflow-hidden'>
			<RiParentLine className="absolute bottom-[20px] left-[-40px] w-40 h-40 sm:w-64 sm:h-64 text-white opacity-10 pointer-events-none z-0" />

			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-4 relative z-10'>
				<h1 className="text-4xl lg-text-5xl font-bold text-white mb-10 drop-shadow-sm header uppercase text-center">
					Эцэг эхийн булан
				</h1>

				<div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
					{(Object.keys(modalContent) as ModalKey[]).map((key) => (
						<button
							key={key}
							onClick={() => openModal(key)}
							className="bg-white text-brandsky-900 p-4 rounded-xl font-medium shadow hover:bg-gray-100 transition flex flex-col items-center text-center"
						>
							{modalContent[key].icon}
							<div className='h-18 px-4 flex items-center text-lg'>{modalContent[key].title}</div>
							<div className='text-xs w-full gap-2 flex flex-row items-center justify-end'>
								Дэлгэрэнгүй унших
								<HiMagnifyingGlass/>
							</div>
						</button>
					))}
				</div>

				
			</div>

			{activeModal && (
				<Modal
					title={modalContent[activeModal].title}
					isOpen={true}
					onClose={closeModal}
				>
					{modalContent[activeModal].html}
				</Modal>
			)}
		</div>
	)
}
